import { render } from "./Lists.vue?vue&type=template&id=3938f1ee&scoped=true"
import script from "./Lists.vue?vue&type=script&lang=js"
export * from "./Lists.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-3938f1ee"

export default script